import { ButtonRadioGroupField } from '@cian/components';
import { Checkbox } from '@cian/checkbox-component';
import { OutsideClick } from '@cian/outside-click-component';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { FDealType, FOfferType } from '../../utils/category';
import { getOfferTypeLabel } from '../../utils/offerType';
import { normalizeOfferType, getOfferTypeList } from './helpers';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterOfferType.css';

export interface IFilterOfferTypeProps {
  dealType: FDealType;
  offerType: FOfferType;
  onSelect(offerType: FOfferType): void;
}

export interface IFilterOfferTypeState {
  active: boolean;
}

export class FilterOfferType extends React.Component<IFilterOfferTypeProps, IFilterOfferTypeState> {
  public state: IFilterOfferTypeState = {
    active: false,
  };

  public render() {
    const { dealType, offerType } = this.props;
    const { active } = this.state;

    const offerTypes = getOfferTypeList(dealType, offerType);
    const offerTypeLabel = getOfferTypeLabel(dealType, offerType);

    return (
      <OutsideClick
        rootElement={<div
          {...mergeStyles(stylesCommon['container'], styles['container'])}
          data-mark="FilterOfferType"
        />}
        onOutsideClick={this.handleOutsideClick}
      >
        <button {...mergeStyles(
            stylesCommon['button'],
            active ? stylesCommon['button--active'] : undefined,
          )}
          title={offerTypeLabel || undefined}
          onClick={this.handleButtonClick}
        >
          {offerTypeLabel || 'Недвижимость'}
        </button>
        {active && <div className={styles['dropdown']}>
          {dealType !== FDealType.RentDaily && <ButtonRadioGroupField
            containerStyle={styles['radio-group']}
            buttonStyle={styles['radio-button']}
            activeButtonStyle={styles['radio-button--active']}
            value={String(normalizeOfferType(offerType))}
            values={[
              { value: String(FOfferType.Residential), label: 'Жилая' },
              { value: String(FOfferType.Commercial), label: 'Коммерческая' },
            ]}
            onValueChange={(offerTypeString) => this.handleRadioButtonClick(Number(offerTypeString))}
          />}
          <ul className={styles['list']}>
            {offerTypes.map((part, index) => <li key={`part_${index}`}>
              <ul className={styles['list-inner']}>
                {part.map((item) => <li key={`item_${item.label}`}>
                  <Checkbox
                    label={item.label}
                    value={(offerType & item.value) !== 0}
                    onValueChange={() => this.handleOfferTypeSelect(item.value)}
                  />
                </li>)}
              </ul>
            </li>)}
          </ul>
        </div>}
      </OutsideClick>
    );
  }

  private handleButtonClick = () => {
    this.setState((state) => ({
      active: !state.active,
    }));
  }

  private handleOutsideClick = () => {
    this.setState({
      active: false,
    });
  }

  private handleRadioButtonClick = (offerType: FOfferType) => {
    this.handleOfferTypeSelect(offerType === FOfferType.Residential ? FOfferType.Flat : FOfferType.Office);
  }

  private handleOfferTypeSelect = (offerType: FOfferType) => {
    if (offerType === this.props.offerType) {
      return;
    }

    if ([FOfferType.FlatOld, FOfferType.FlatNew].includes(offerType)
      && (this.props.offerType & FOfferType.Flat) !== 0
    ) {
      if (this.props.offerType === FOfferType.Flat) {
        this.props.onSelect(offerType === FOfferType.FlatOld ? FOfferType.FlatNew : FOfferType.FlatOld);
      } else {
        this.props.onSelect(FOfferType.Flat);
      }

      return;
    }

    this.props.onSelect(offerType);
  }
}
